import type { HttpClient } from "../http";
import type { CartDTO, PushToCartRequest } from "../types";

export function cartsResource(http: HttpClient) {
  return {
    get: (retailerId: number) => http.get<CartDTO>(`/carts/retailer/${retailerId}`),
    push: (body: PushToCartRequest) => http.post<CartDTO>(`/carts/retailer/${body.retailerId}/push`, body),
    updateQty: (retailerId: number, skuId: number, qty: number, updatedBy?: string, packId?: number | null) =>
      http.put<CartDTO>(`/carts/retailer/${retailerId}/items/${skuId}?qty=${qty}&updatedBy=${encodeURIComponent(updatedBy || "SYSTEM")}${packId != null ? `&packId=${packId}` : ""}`),
    removeItem: (retailerId: number, skuId: number, packId?: number | null) =>
      http.del<CartDTO>(`/carts/retailer/${retailerId}/items/${skuId}${packId != null ? `?packId=${packId}` : ""}`),
    clear: (retailerId: number) => http.del<void>(`/carts/retailer/${retailerId}`),
  };
}
